import { render, staticRenderFns } from "./GalleryDialog.vue?vue&type=template&id=5fbeb22c&scoped=true"
import script from "./GalleryDialog.vue?vue&type=script&lang=ts"
export * from "./GalleryDialog.vue?vue&type=script&lang=ts"
import style0 from "./GalleryDialog.vue?vue&type=style&index=0&id=5fbeb22c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbeb22c",
  null
  
)

export default component.exports